/*
 */
'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _tool = require("@entrylabs/tool");
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0, _get2["default"])((0, _getPrototypeOf2["default"])(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
/*
 *
 */
Entry.FieldDropdownDynamic = /*#__PURE__*/function (_Entry$FieldDropdown) {
  function FieldDropdownDynamic(content, blockView, index) {
    var _this;
    (0, _classCallCheck2["default"])(this, FieldDropdownDynamic);
    _this = _callSuper(this, FieldDropdownDynamic, [content, blockView, index, null, null, true]);
    _this._block = blockView.block;
    _this._blockView = blockView;
    var box = new Entry.BoxModel();
    _this.box = box;
    _this.svgGroup = null;
    _this._contents = content;
    if (content.needDeepCopy) {
      _this._contents = (0, _cloneDeep2["default"])(content);
    }
    _this._index = index;
    var bgColor = content.bgColor,
      textColor = content.textColor,
      arrowColor = content.arrowColor;
    if (_this._block.deletable === Entry.Block.DELETABLE_FALSE_LIGHTEN || _this._block.emphasized) {
      arrowColor = blockView._fillColor;
    }
    _this._arrowColor = arrowColor;
    _this._textColor = textColor || '#FFFFFF';
    _this._bgColor = bgColor;
    var menuName = _this._contents.menuName;
    if (_.isFunction(menuName)) {
      _this._menuGenerator = menuName;
    } else {
      _this._menuName = menuName;
    }
    _this._CONTENT_HEIGHT = _this.getContentHeight(content.dropdownHeight);
    _this._font_size = _this.getFontSize(content.fontSize);
    _this._ROUND = content.roundValue || 3;
    _this.initialize(blockView);
    return _this;
  }
  (0, _inherits2["default"])(FieldDropdownDynamic, _Entry$FieldDropdown);
  return (0, _createClass2["default"])(FieldDropdownDynamic, [{
    key: "initialize",
    value: function initialize(blockView) {
      var _this2 = this;
      var promise = this.renderStart(blockView);
      if (blockView && blockView.getBoard() && blockView.getBoard().workspace && blockView.getBoard().workspace.changeEvent) {
        blockView.getBoard().workspace.changeEvent.attach(this, function () {
          _this2._updateValue(true);
        });
      }
      if (promise instanceof Promise) {
        promise.then(function () {
          blockView.alignContent(false);
        });
      }
    }
  }, {
    key: "_isBlockInBoardWhenFunctionEdit",
    value: function _isBlockInBoardWhenFunctionEdit() {
      var view = this._block.getView() || {
        _board: {}
      };
      return view._board.suffix === 'board' && Entry.Func.isEdit;
    }
  }, {
    key: "getTextByValue",
    value: function getTextByValue(value) {
      if (this._isBlockInBoardWhenFunctionEdit()) {
        return this.textElement.textContent;
      }
      return _superPropGet(FieldDropdownDynamic, "getTextByValue", this, 3)([value]);
    }
  }, {
    key: "updateValue",
    value: function updateValue(reDraw) {
      return this._updateValue(reDraw);
    }
  }, {
    key: "_updateValue",
    value: function () {
      var _updateValue2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(reDraw) {
        var object, options;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              object = this._block.getCode().object;
              options = [];
              if (!Entry.container) {
                _context.next = 4;
                break;
              }
              if (!this._menuName) {
                _context.next = 2;
                break;
              }
              _context.next = 1;
              return Entry.container.getDropdownList(this._menuName, object);
            case 1:
              options = _context.sent;
              _context.next = 4;
              break;
            case 2:
              _context.next = 3;
              return this._menuGenerator(this._block);
            case 3:
              options = _context.sent;
              if (options.length === 0) {
                options = [[Lang.Blocks.no_target, 'null']];
              }
            case 4:
              this._contents.options = options;
              this._updateOptions();
              if (reDraw && this._menuName === 'variables' && !this._isBlockInBoardWhenFunctionEdit()) {
                this.value = undefined;
              }
              this.applyValue(this.getOptionCheckedValue(), reDraw);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _updateValue(_x) {
        return _updateValue2.apply(this, arguments);
      }
      return _updateValue;
    }()
  }, {
    key: "getTargetValue",
    value: function getTargetValue(key) {
      var useParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!key) {
        return;
      }
      var block = useParent ? this._block.thread._block : this._block;
      var _ref = block || {},
        _schema = _ref._schema,
        _ref$params = _ref.params,
        values = _ref$params === void 0 ? [] : _ref$params;
      var _ref2 = _schema || {},
        _ref2$params = _ref2.params,
        params = _ref2$params === void 0 ? [] : _ref2$params;
      var idx = params.findIndex(function (_ref3) {
        var dropdownSync = _ref3.dropdownSync;
        return dropdownSync === key;
      });
      return values[idx || 0];
    }
  }, {
    key: "getOptionCheckedValue",
    value: function getOptionCheckedValue() {
      var _this$_contents = this._contents,
        _this$_contents$optio = _this$_contents.options,
        options = _this$_contents$optio === void 0 ? [] : _this$_contents$optio,
        defaultValue = _this$_contents.defaultValue;
      var value = this.getValue();
      if (this._blockView.isInBlockMenu || !value || value == 'null') {
        value = options.length !== 0 && options[0] ? options[0][1] : null;
      }
      var matched = _.find(options, function (_ref4) {
        var _ref5 = (0, _slicedToArray2["default"])(_ref4, 2),
          cValue = _ref5[1];
        return cValue === value;
      });
      if (!matched && defaultValue) {
        if (_.isFunction(defaultValue)) {
          return defaultValue(value, options);
        }
        return defaultValue;
      }
      return value;
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var _this3 = this;
      this.optionGroup = Entry.Dom('div', {
        "class": 'entry-widget-dropdown',
        parent: $('body')
      });
      var _this$_contents$optio2 = this._contents.options,
        options = _this$_contents$optio2 === void 0 ? [] : _this$_contents$optio2;
      var convertedOptions = options.map(function (_ref6) {
        var _ref7 = (0, _slicedToArray2["default"])(_ref6, 2),
          key = _ref7[0],
          value = _ref7[1];
        return [_this3._convert(key, value), value];
      });
      this.dropdownWidget = new _tool.Dropdown({
        data: {
          eventTypes: ['mousedown', 'touchstart', 'wheel'],
          items: convertedOptions,
          positionDom: this.svgGroup,
          onOutsideClick: function onOutsideClick() {
            _this3.destroyOption();
          }
        },
        container: this.optionGroup[0]
      }).on('select', function (item) {
        _this3.applyValue(item[1]);
        _this3.destroyOption();
        var _this3$_block$getThre = _this3._block.getThread(),
          _this3$_block$getThre2 = _this3$_block$getThre.view,
          view = _this3$_block$getThre2 === void 0 ? {} : _this3$_block$getThre2;
        if (view.reDraw) {
          view.reDraw();
        } else {
          _this3._block.view.reDraw();
        }
      });
      this.optionDomCreated();
    }
  }]);
}(Entry.FieldDropdown);